import React from 'react';
import { ChartBar20 } from '@carbon/icons-react';
import type { Product } from '#config/products';
import type Products from '.';

const productPage = (productName: keyof typeof Products) => async () => {
  const products = (await import('.')).default;
  return {
    default: products[productName],
  };
};

const DocumentLibrary = React.lazy(productPage('DocumentLibrary'));

const resourcesConfig: Product = {
  name: 'Resources Hub',
  authKey: 'resources',
  description: 'Access your brand kit and supporting documentation',
  path: 'resources',
  icon: ChartBar20,
  color: 'redOrange',
  productConfig: {
    topbar: {
      title: 'Resources',
      titleAcronym: 'Resources',
    },
  },
  pages: [
    {
      name: 'Resources Hub',
      path: 'resources-hub',
      component: DocumentLibrary,
      pageConfig: {},
    },
  ],
};

export default resourcesConfig;
